import { render, staticRenderFns } from "./MTalentHome.vue?vue&type=template&id=d32b7228&"
import script from "./MTalentHome.vue?vue&type=script&lang=js&"
export * from "./MTalentHome.vue?vue&type=script&lang=js&"
import style0 from "./MTalentHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports